module.exports = __webpack_public_path__ + "static/media/product-hunt.66117d27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/site-menu/assets/product-hunt.svg
// module id = 18
// module chunks = 0